/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DisplayState = {
    Idle: 'Idle',
    Scanning: 'Scanning',
    DriveAuthorized: 'DriveAuthorized',
    DriveUnlicensed: 'DriveUnlicensed',
    DriveWrongZone: 'DriveWrongZone',
    DeniedNoRight: 'DeniedNoRight',
    DeniedExpired: 'DeniedExpired',
    DeniedPoolFull: 'DeniedPoolFull',
    Full: 'Full',
    DriveAuthorizedOverflowOrgPays: 'DriveAuthorizedOverflowOrgPays',
    DriveAuthorizedOverflowParkerPays: 'DriveAuthorizedOverflowParkerPays',
    EntryClosed: 'EntryClosed',
    ExitIdle: 'ExitIdle',
    ExitFree: 'ExitFree',
    ExitViolations: 'ExitViolations',
    PaymentRequired: 'PaymentRequired',
    PaymentInProgress: 'PaymentInProgress',
    PaymentDone: 'PaymentDone',
    NoEntryRecord: 'NoEntryRecord',
    PaymentRequiredQr: 'PaymentRequiredQr',
    PaymentRequiredCardNfc: 'PaymentRequiredCardNfc',
    PaymentRequiredTerminal: 'PaymentRequiredTerminal',
    PaymentFailed: 'PaymentFailed',
    ExitClosed: 'ExitClosed',
    Emergency: 'Emergency',
    Maintenance: 'Maintenance',
    CustomMessage: 'CustomMessage',
    Fallback: 'Fallback'
} as const;
export type DisplayState = typeof DisplayState[keyof typeof DisplayState];

